import { Inject, Options, Vue, Watch } from "vue-property-decorator";
import { TrustAPI } from "@/shared/modules/trust-api";
import { AppInsights } from "@/trust-admin-app/appInsights";
import store from "@/trust-admin-app/store";
import { EventEmitter } from "events";
import ModalBox from "@/shared/components/modal-box/index.vue";
import LoadingSpinner from "@/shared/components/loading-spinner/index.vue";
import LoadingIndicator from "@/shared/components/loading-indicator/index.vue";
import ErrorIndicator from "@/shared/components/error-indicator/index.vue";
import { ComplianceFormAbsolutionRequest, PartAResubmissionRequestRequest, PartBResubmissionRequestRequest, PracticeView } from "@/shared/modules/typescript-trustapi-client/models";
import FormatDateTimeMixin from '@/shared/mixins/format-datetime';
import ToggleSwitchV2 from '@/shared/components/toggle-switchV2/index.vue';


@Options({
  props: {
    practice: Object,
    actionType: String,
  },
  components: {
    ModalBox,
    LoadingSpinner,
    LoadingIndicator,
    ErrorIndicator,
    ToggleSwitchV2,
  },
  mixins: [FormatDateTimeMixin],
})
export default class ActionModal extends Vue {
  private practice!: any;
  private actionType!: string;

  private loadingContent = false;
  private errorLoadingContent = false;
  private isSaving = false;

  private savingText = 'Saving...';

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  private ai = new AppInsights;

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  private fileList: any[] = [];
  private selectedFileForPreview: any = {};
  private blob: any;
  private documentURL: string = null as any;

  private isAbsolvedPartA = false;
  private isDisabledPartA = false;
  private isAbsolvedPartB = false;
  private isDisabledPartB = false;
  private isAbsolvedEeReport = false;
  private isDisabledEeReport = false;

  private comments = '';
  private sendNotification = false;

  @Watch('isAbsolvedPartA')
  private onIsAbsolvedPartAChanged(value: boolean): void {
    this.setCheckboxes('a');
  }

  @Watch('isAbsolvedPartB')
  private onIsAbsolvedPartBChanged(value: boolean): void {
    this.setCheckboxes('b');
  }

  @Watch('isAbsolvedEeReport')
  private onIsAbsolvedEeReportChanged(value: boolean): void {
    this.setCheckboxes('c');
  }

  private setCheckboxes(a: string): void {
    switch (a) {
      case 'a':
        if (this.isAbsolvedPartA) {
          this.isAbsolvedPartB = true;
          this.isDisabledPartB = true;
          this.isAbsolvedEeReport = true;
          this.isDisabledEeReport = true;
        } else {
          this.isAbsolvedPartB = false;
          this.isDisabledPartB = false;
          this.isAbsolvedEeReport = false;
          this.isDisabledEeReport = false;
        }
        break;
      case 'b':
        if (this.isAbsolvedPartB) {
          this.isAbsolvedEeReport = true;
          this.isDisabledEeReport = true;
        } else {
          this.isAbsolvedEeReport = false;
          this.isDisabledEeReport = false;
        }
        break;
      case 'c':
      // if (this.isAbsolvedEeReport) {
      //   this.isAbsolvedPartA = true;
      //   this.isDisabledPartA = true;
      //   this.isAbsolvedPartB = true;
      //   this.isDisabledPartB = true;
      // } else {
      //   this.isAbsolvedPartA = false;
      //   this.isDisabledPartA = false;
      //   this.isAbsolvedPartB = false;
      //   this.isDisabledPartB = false;
      // }
      // break;
    }

  }

  mounted(): void {
    // if (this.actionType === 'file-attachment') {
    //   this.getFiles();
    // } else {

    // }
    switch (this.actionType) {
      case 'file-attachment':
        this.getFiles();
        break;
      case 'multiple-part-a':
        this.getMultiplePartA();
        break;
      case 'multiple-part-b':
        this.getMultiplePartB();
        break;
      case 'multiple-eer':
        this.getMultipleEER();
        break;

    }
    this.isAbsolvedPartA = this.practice.isAbsolvedPartA;
    this.isAbsolvedPartB = this.practice.isAbsolvedPartB;
    this.isAbsolvedEeReport = this.practice.isAbsolvedEeReport;
  }

  private async getFiles(): Promise<void> {
    this.loadingContent = true;
    await this.apiService.ComplianceFormApi?.apiV2ComplianceFormAdminGetComplianceFormFilesComplianceFormIdGet(
      this.practice.id
    )
      .then(res => {
        this.fileList = res.data as any;
        this.loadingContent = false;
      })
      .catch(err => {
        this.eventCtrl.emit('show-snackbar', 'error', 'Unable to load file list');
        this.ai.trackException('Error getting load file list: ' + err);
        this.loadingContent = false;
        this.errorLoadingContent = true;
      })
  }

  private async getMultiplePartA(): Promise<void> {
    this.loadingContent = true;
    await this.apiService.FileAtcsApi?.apiV2FileAtcsAdminGetPartAFileLogsPartAIdGet(
      this.practice.partA.id
    )
      .then(res => {
        this.fileList = res.data.data as any;
        this.loadingContent = false;
      })
      .catch(err => {
        this.eventCtrl.emit('show-snackbar', 'error', 'Unable to load PDF file list');
        this.ai.trackException('Error getting Part A PDF file list: ' + err);
        this.loadingContent = false;
        this.errorLoadingContent = true;
      })
  }

  private async getMultiplePartB(): Promise<void> {
    this.loadingContent = true;
    await this.apiService.FileAtcsApi?.apiV2FileAtcsAdminGetPartBFileLogsPartBIdGet(
      this.practice.partB.id
    )
      .then(res => {
        this.fileList = res.data.data as any;
        this.loadingContent = false;
      })
      .catch(err => {
        this.eventCtrl.emit('show-snackbar', 'error', 'Unable to load PDF file list');
        this.ai.trackException('Error getting Part B PDF file list: ' + err);
        this.loadingContent = false;
        this.errorLoadingContent = true;
      })
  }

  private async getMultipleEER(): Promise<void> {
    this.loadingContent = true;
    await this.apiService.FileAtcsApi?.apiV2FileAtcsAdminGetEeReportFileLogsEeReportIdGet(
      this.practice.eeReport.id
    )
      .then(res => {
        this.fileList = res.data.data as any;
        this.loadingContent = false;
      })
      .catch(err => {
        this.eventCtrl.emit('show-snackbar', 'error', 'Unable to load PDF file list');
        this.ai.trackException('Error getting EER PDF file list: ' + err);
        this.loadingContent = false;
        this.errorLoadingContent = true;
      })
  }

  private closeModal(): void {
    this.$emit('closeModal');
  }

  private confirm(actionType: string): void {
    switch (actionType) {
      case 'resubmit-part-a':
        this.resubmitPartA();
        break;
      case 'resubmit-part-b':
        this.resubmitPartB();
        break;
      case 'absolution':
        this.resubmitEEReport();
        break;
    }

  }

  private async resubmitPartA(): Promise<void> {
    this.isSaving = true;
    const body: PartAResubmissionRequestRequest = {
      partAId: this.practice.partA.id,
      comment: this.comments,
      isSendNotification: this.sendNotification ?? false
    }
    await this.apiService.PartAFormApi?.apiV2PartAFormAdminSavePartAResubmissionRequestPost(body)
      .then(() => {
        this.eventCtrl.emit('show-snackbar', 'success', 'Part A resubmission request sent');
        setTimeout(() => {
          this.$emit('reloadData');
          this.isSaving = false;
          this.closeModal();
        }, 500);
      })
      .catch(err => {
        this.eventCtrl.emit('show-snackbar', 'error', 'Unable to resubmit Part A');
        this.ai.trackException('Error resubmitting Part A: ' + err);
        this.isSaving = false;
      })

  }

  private async resubmitPartB(): Promise<void> {
    this.isSaving = true;
    const body: PartBResubmissionRequestRequest = {
      partBId: this.practice.partB.id,
      comment: this.comments,
      isSendNotification: this.sendNotification ?? false
    }
    await this.apiService.PartBFormApi?.apiV2PartBFormAdminSavePartBResubmissionRequestPost(body)
      .then(() => {
        this.eventCtrl.emit('show-snackbar', 'success', 'Part B resubmission request sent');
        setTimeout(() => {
          this.$emit('reloadData');
          this.isSaving = false;
          this.closeModal();
        }, 500);
      })
      .catch(err => {
        this.eventCtrl.emit('show-snackbar', 'error', 'Unable to resubmit Part B');
        this.ai.trackException('Error resubmitting Part B: ' + err);
        this.isSaving = false;
      })
  }

  private async resubmitEEReport(): Promise<void> {
    this.isSaving = true;
    const body: ComplianceFormAbsolutionRequest = {
      complianceFormId: this.practice.id,
      isAbsolvedPartA: this.isAbsolvedPartA,
      isAbsolvedPartB: this.isAbsolvedPartB,
      isAbsolvedEeReport: this.isAbsolvedEeReport,
      isSendNotification: this.sendNotification ?? false
    }
    await this.apiService.ComplianceFormApi?.apiV2ComplianceFormAdminUpdateComplianceFormAbsolutionPost(
      body
    )
      .then(() => {
        this.eventCtrl.emit('show-snackbar', 'success', 'Absolution sent');
        setTimeout(() => {
          this.isSaving = false;
          this.$emit('reloadData');
          this.closeModal();
        }, 500);
      })
      .catch(err => {
        this.eventCtrl.emit('show-snackbar', 'error', 'Unable to sent absolution');
        this.ai.trackException('Error sending absolution: ' + err);
        this.isSaving = false;
      })
  }

  private async downloadFile(file: any) {
    await this.apiService.FileAtcsApi?.apiV2FileAtcsAdminDownloadStreamFileIdGet(
      file.id, { responseType: 'blob' }
    )
      .then((res: any) => {
        this.selectedFileForPreview.FileStream = res.data;
        this.selectedFileForPreview.ContentType = res.headers['content-type'];
        this.selectedFileForPreview.FileName = file.fileName
        this.download();
      })
      .catch((err: any) => {
        this.ai.trackException('Unable to download file ' + err);
        this.eventCtrl.emit('show-snackbar', 'error', 'Unable to download file: ' + err);
      })
  }


  private download() {
    this.blob = new Blob([this.selectedFileForPreview.FileStream], { type: this.selectedFileForPreview.ContentType });
    this.documentURL = window.URL.createObjectURL(this.blob);
    const downloadLink = document.createElement('a');
    const fileName = this.selectedFileForPreview.FileName;
    downloadLink.href = this.documentURL;
    downloadLink.download = fileName as string;
    downloadLink.click();
  }

  get selectedPractice(): PracticeView {
    return store.getters.getSelectedPractice;
  }

  get showConfirmButton(): boolean {
    return this.actionType === 'resubmit-part-a' || this.actionType === 'resubmit-part-b' || this.actionType === 'absolution';
  }

  private async viewPDF(fileId: number): Promise<void> {
    let apiCall = null;
    switch (this.actionType) {
      case 'multiple-part-a':
        apiCall = this.apiService.FileAtcsApi?.apiV2FileAtcsAdminGetPartAFilePartAIdRegeneratedFileLogIdGet(this.practice.partA.id, fileId);
        break;
      case 'multiple-part-b':
        apiCall = this.apiService.FileAtcsApi?.apiV2FileAtcsAdminGetPartBFilePartBIdRegeneratedFileLogIdGet(this.practice.partB.id, fileId);
        break;
      case 'multiple-eer':
        apiCall = this.apiService.FileAtcsApi?.apiV2FileAtcsAdminGetEeReportFileEeReportIdRegeneratedFileLogIdGet(this.practice.eeReport.id, fileId);
        break;
      default:
        console.log('Invalid API action type', this.actionType);
        break;
    }
    try {
      const resp: any = await apiCall;
      const base64Data = resp.data.data.base64AsString;
      const base64Response = await fetch(`data:application/pdf;base64,${base64Data}`);
      const blob = await base64Response.blob();
      const documentURL = window.URL.createObjectURL(blob);
      window.open(documentURL, '_blank');
      setTimeout(() => {
        URL.revokeObjectURL(documentURL);
      }, 300000);
      Promise.resolve(0);
    } catch (e: any) {
      this.eventCtrl.emit('show-snackbar', 'error', 'Error on opening PDF: ' + e?.response?.data?.message);
      Promise.resolve(0);
    }
  }

  private showSendNotificaitonButton(): boolean {
    return this.actionType === 'resubmit-part-a' || this.actionType === 'resubmit-part-b' || this.actionType === 'absolution';
  }

}

